import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { GitMerge } from "lucide-react";

export default function Matrix() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/matrix").then((r) => setRows(r.data)); }, []);
  const f = rows.filter((r) => {
    if (!q) return true;
    const s = q.toLowerCase();
    return [r.user_name, r.position, r.course].some((x) => (x || "").toLowerCase().includes(s));
  });
  const status = (s) => s === "completed" ? "bg-emerald-100 text-emerald-700"
    : s === "in_progress" ? "bg-amber-100 text-amber-700"
    : "bg-slate-100 text-slate-600";
  const label = (s) => ({ completed: "Concluído", in_progress: "Em andamento", pending: "Pendente" }[s] || s);
  return (
    <div className="space-y-8" data-testid="matrix-page">
      <header>
        <div className="eyebrow">Compliance</div>
        <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight mt-1">Matriz de capacitação</h1>
        <p className="text-slate-600 mt-2 text-sm">Cruzamento de cargos × treinamentos obrigatórios × status por colaborador.</p>
      </header>
      <Input placeholder="Buscar por colaborador, cargo ou curso…" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-md" data-testid="matrix-search" />
      <Card><CardContent className="p-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-4 py-3">Colaborador</th>
              <th className="px-4 py-3">Cargo</th>
              <th className="px-4 py-3">Curso</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Progresso</th>
            </tr>
          </thead>
          <tbody>
            {f.length === 0 && <tr><td colSpan="5" className="px-4 py-10 text-center text-slate-500"><GitMerge className="w-8 h-8 mx-auto mb-2 text-slate-400" />Sem registros para a matriz ainda.</td></tr>}
            {f.map((r, i) => (
              <tr key={i} className="border-t border-[var(--unigr-border)]">
                <td className="px-4 py-3">{r.user_name}</td>
                <td className="px-4 py-3">{r.position}</td>
                <td className="px-4 py-3">{r.course}</td>
                <td className="px-4 py-3"><span className={"px-2 py-1 rounded text-xs " + status(r.status)}>{label(r.status)}</span></td>
                <td className="px-4 py-3">{r.progress}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent></Card>
    </div>
  );
}
